<template>
	<form @submit.prevent="onSubmitForm" class="engine-form">
		<div class="row">
			<div class="col-12">
				<base-input
					label="Nome"
					v-validate="'required|min:2'"
					:error="getError('Nome')"
					v-model="model.name"
					name="Name"
					input-size="form-control-lg"
					placeholder="Nome"
				>
				</base-input>
				<base-input
					label="Matricola"
					v-validate="'required|min:2'"
					:error="getError('matricola')"
					v-model="model.registrationNumber"
					name="matricola"
					input-size="form-control-lg"
					placeholder="Matricola motore"
				>
				</base-input>
				<base-input
					label="Modello"
					v-validate="'required|min:2'"
					:error="getError('model')"
					v-model="model.model"
					name="model"
					input-size="form-control-lg"
					placeholder="Veicolo"
				>
				</base-input>
				<base-input
					label="Descrizione"
					input-size="form-control-lg"
					placeholder="Descrizione"
				>
				<textarea
					placeholder="Aggiungi una descrizione qui"
					:error="getError('Nome')"
					v-model="model.description"
					name="description"
					:class="`form-control form-control-lg`"
					aria-describedby="addon-right addon-left" />
				</base-input>
				<!--div class="row">
					<div class="col-12 col-md-8">
						<base-input
							type="number"
							label="Ripetitività revisione (numero di giorni)"
							v-model="model.revisionRepeatDuration"
							name="revisionRepeatDuration"
							input-size="form-control-lg"
							placeholder="90"
						/>
					</div>
					<div class="col-12 col-md-4">
						<div class="form-groupo">
							<label>Stato contratto revisione</label>
							<br>
			                <base-switch
								v-model="model.revisionsStatus"
								on-text='Attivo'
								off-text="disattivo"
			                ></base-switch>
						</div>
					</div>
				</div-->
			</div>
			<div class="col-12 text-center text-md-right">
				<base-button type="primary" native-type="submit">
	    			<i class="icon-cloud-upload-94 tim-icons" />
					{{submitMessage}}
				</base-button>
			</div>
		</div>
	</form>
</template>
<script>

import {
  BaseSwitch,
  ImageUpload,
} from 'src/components/index';

import { mapState, mapActions } from 'vuex'

export default {
	name: 'engine-form',
	props: {
		model: Object,
		onSubmit: Function,
		submitMessage: {
			type: String,
			default: 'Salva',
		}
	},
	components: {
		BaseSwitch,
		ImageUpload
	},
	computed: {
		...mapState({
			attachmentLoading: state => state.engines.attachmentLoading
		})
	},
	methods: {
	    ...mapActions('engines', {
	      addAttachment: 'addAttachment',
	    }),
	    changeRevisionsStatus(value) {
	    	this.model.revisionsStatus = value ? 'activated' : 'disabled'
	    },
	    onImageChange(attachment) {
	    	if (attachment){
		    	this.addAttachment({
		    		engineId : this.$route.params.id,
		    		attachment
		    	});
	    	}
	    },
		async onSubmitForm() {
		      let isValidForm = await this.$validator.validate();
		      if (isValidForm) {
		      	this.onSubmit();
		      }
		},
		getError(fieldName) {
		  return this.errors.first(fieldName);
		},
		addEmail() {
			this.model.emails.push({
				email: '',
				contactName: '',
				primary: this.model.emails.length === 0
			})
		},
		deleteEmail(index) {
			this.model.emails.splice(index,1)
		}
	}
}
</script>
<style lang="scss">
.engine-form{
	.bootstrap-switch {
		width: 100px !important;
		.bootstrap-switch-container{
			width: 100% !important;
		}
		.bootstrap-switch-label{
			left: 90%;
		}
	}
	.text-small{
		font-size: 0.8em;
	}
	.add-image{
		.fileinput{
			margin:auto;
			display: block;
		}
		img{
			max-width: 100px;
			&[src*="blob"]{
				max-width: 100%;
			}
		}
	}
}
</style>